import { createReducer, on } from '@ngrx/store';
import * as EventsActions from './events.actions';
import * as AuthActions from '../auth/auth.actions';
import { EventsState, initialState } from './events.state';
import { mergeCalendarEventLists } from './events-calendar-cache.util';

export const eventsReducer = createReducer(
  initialState,
  on(AuthActions.resetAllState, () => {
    return initialState;
  }),
  on(EventsActions.loadCalendarEvents, (state, { queryParams, replaceCache }) => {
    const requestId = `${Date.now()}-${Math.random()}`;
    return {
      ...state,
      calendar: {
        ...state.calendar,
        loading: true,
        error: null,
        pendingReplaceCache: replaceCache === true,
        pendingQueryParams: queryParams ?? null,
      },
      pendingRequestId: requestId
    };
  }),
  on(EventsActions.loadCalendarEventsSuccess, (state, { data, queryParams }) => {
    const resolvedParams =
      queryParams ?? state.calendar.pendingQueryParams ?? state.calendar.lastQueryParams;
    const replaceCache = state.calendar.pendingReplaceCache;
    const merged = mergeCalendarEventLists(
      state.calendar.data,
      data,
      resolvedParams as { startDate?: string; endDate?: string },
      replaceCache
    );
    return {
      ...state,
      calendar: {
        ...state.calendar,
        data: merged,
        loading: false,
        error: null,
        lastUpdated: Date.now(),
        lastQueryParams: resolvedParams,
        pendingReplaceCache: false,
        pendingQueryParams: null,
      },
      pendingRequestId: null
    };
  }),
  on(EventsActions.loadCalendarEventsFailure, (state, { error }) => {
    return {
      ...state,
      calendar: {
        ...state.calendar,
        data: [],
        loading: false,
        error,
        lastUpdated: Date.now(),
        lastQueryParams: null,
        pendingReplaceCache: true,
        pendingQueryParams: null,
      },
      pendingRequestId: null
    };
  }),
  on(EventsActions.cancelCalendarEventsLoad, (state) => {
    return {
      ...state,
      calendar: {
        ...state.calendar,
        loading: false
      },
      pendingRequestId: null
    };
  }),
  on(EventsActions.updateEventsFilters, (state, { filters }) => {
    return {
      ...state,
      filters
    };
  }),
  on(EventsActions.clearEventsData, () => {
    return initialState;
  })
);

